/*
 * @Author: maxiyan
 * @Date: 2023-03-28
 * @Description: 采用map实现
 */

export class LRUCache<K, T> {
  private capacity: number;
  private cache: Map<K, T>;

  constructor(capacity = 10, initCache?: Array<[K, T]> | Map<K, T>) {
    this.capacity = capacity;
    if (initCache && Object.keys(initCache).length > 0) {
      this.cache = Array.isArray(initCache) ? new Map(initCache) : initCache;
    } else {
      this.cache = new Map();
    }
  }

  get(key: K) {
    const value = this.cache.get(key);
    if (value) {
      this.cache.delete(key);
      this.cache.set(key, value);
    }
    return value;
  }

  put(key: K, value: T) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
      this.cache.set(key, value);
    } else {
      this.cache.set(key, value);
      if (this.cache.size > this.capacity) {
        this.cache.delete(this.cache.keys().next().value);
      }
    }
  }

  delete(key: K) {
    this.cache.delete(key);
  }

  exportCache() {
    return this.cache;
  }
}
